import React from "react";
import PropTypes from "prop-types";

/**
 * EventList - horizontálny carousel na zobrazovanie dátumov vývozu odpadu.
 * @param {Object[]} items - Pole udalostí [{ date, title, color }]
 * @param {string} [title] - Nadpis sekcie
 */
export default function EventList({ items = [], title }) {
  if (!items.length) return null;

  const formatDateParts = (dateString) => {
    if (!dateString) return { day: "", month: "" };
    try {
      const date = new Date(dateString);
      return {
        day: date.getDate(),
        month: date.toLocaleString("sk-SK", { month: "short" }).toUpperCase().replace(".", ""),
      };
    } catch (e) {
      return { day: "?", month: "Neplatný dátum" };
    }
  };

  return (
    <div style={{ margin: "16px 0" }}>
      {title && (
        <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 12, paddingLeft: 4 }}>
          {title}
        </div>
      )}
      <div
        style={{
          display: "flex",
          overflowX: "auto",
          gap: 12,
          padding: "4px 4px 12px 4px",
          WebkitOverflowScrolling: "touch",
          scrollbarWidth: "thin",
          scrollbarColor: "#ccc #f1f1f1",
        }}
      >
        {items.map((item, idx) => {
          const { day, month } = formatDateParts(item.date);
          const itemColor = item.color || "#1976d2";

          return (
            <div
              key={idx}
              style={{
                minWidth: 120,
                background: "#fff",
                borderRadius: 12,
                boxShadow: "0 3px 10px rgba(0,0,0,0.07)",
                padding: "12px 10px",
                textAlign: "center",
                border: "1px solid #e8e8e8",
                display: "flex",
                flexDirection: "column",
                minHeight: 120,
              }}
            >
              <div>
                <div style={{ fontSize: 28, fontWeight: 700, color: itemColor, lineHeight: 1.1 }}>
                  {day}
                </div>
                <div
                  style={{
                    fontSize: 14,
                    fontWeight: 600,
                    color: "#444",
                    textTransform: "uppercase",
                  }}
                >
                  {month}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "auto",
                  paddingTop: 8,
                }}
              >
                <span
                  style={{
                    display: "inline-block",
                    width: 9,
                    height: 9,
                    borderRadius: "50%",
                    background: itemColor,
                    marginRight: 6,
                    flexShrink: 0,
                  }}
                />
                <span style={{ fontSize: 14, fontWeight: 500, color: "#333", lineHeight: 1.3 }}>
                  {item.title}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

EventList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string,
      title: PropTypes.string,
      color: PropTypes.string,
    })
  ),
  title: PropTypes.string,
};
